// Clinic Configuration for Meadows Dental Care
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Meadows Dental Care",
  clinicId: "meadowsdentalcare",
  clinicUrl: "https://themeadowsdentalcare.com",
  // Contact Information
  phoneNumber: "737-263-1581",
  phoneNumberRaw: "+17372631581", // For tel: and sms: links
  email: "dentist@themeadowsdentalcare.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=meadowsdentalcare&agentId=617de739-29e3-4065-8c65-623f546d8244",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/meadowsdentalcare/voice",

  // Location
  address: "9600 S I-35 Frontage Rd Bldg S #275, Austin, TX 78748, United States",
  addressShort: "9600 S I-35 Frontage Rd Bldg S #275, Austin, TX 78748",
  city: "Austin",
  hcity: "Austin",
  state: "Texas",
  stateShortForm: "TX",
  zipCode: "78748",
  PostalCode: "78748",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/Hz4S86nieDoEJyZi6",
  googleMapsLink: "https://maps.app.goo.gl/Hz4S86nieDoEJyZi6",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d110391.80274745333!2d-97.790959!3d30.158739!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865b4cd65b6356f5%3A0xd2c305273fcbbc82!2sMeadows%20Dental%20Care%20%26%20Orthodontics!5e0!3m2!1sen!2sin!4v1756797635853!5m2!1sen!2sin',
  iframeTitle: "Meadows Dental Care",

  //membership
  membership: "https://member.kleer.com/?slug=UN2K",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalPartners-MeadowsDentalCare",

  // Cherry
  cherryUrl: "https://themeadowsdentalcare.com/patient-portal",

  // Analytics
  clarityProjectId: "q5nl2vx1uk",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/meadowsdentalcare",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/meadowsdentalcare",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/meadowsdentalcare",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://themeadowsdentalcare.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/meadowsdentalcaretx",
    instagram: "https://www.instagram.com/stories/meadows_dentalcare/",
    twitter: "https://x.com/meadows_dent",
    linkedin: "https://www.linkedin.com/company/the-meadows-dental-care/",
    youtube: "https://www.youtube.com/@TheMeadowsDentalCare",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/3212159561455542358/profile?hl=en-GB&fid=15186988034555624578",
    facebook: "https://www.facebook.com/themeadowsdentalcare/",
    yelp: "https://www.yelp.com/biz/meadows-dental-care-austin",
  },

  // Open Dental Configuration
  defaultProvNum: 199,
  defaultOpNum: 6578,

  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 6579,
      AppointmentTypeNum: 10
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 6578,
      AppointmentTypeNum: 9
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 6578,
      AppointmentTypeNum: 5
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "17373177267",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  zipCode,
  mapUrl,
  googleMapsLink,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
